import Swal from 'sweetalert2';
import { CgSpinner } from 'react-icons/cg';
import { APIUtils } from '../../../../../utils/apiutils';
import httpClient from '../../../../../services/http';
import React, { useState } from 'react';
import { Button, DialogActions } from '@mui/material';
import { CUSTOM_EVENTS } from '../../../../../utils/constants';
import { objectToFormData } from '../../../../../utils/utils';
import { useAppointmentContext } from '../contexts/appointmentcontext';

function PrescriptionDialog() {
    const { appointment } = useAppointmentContext();
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    const handlePrescription = (e) => {
        const fileData = e.target.files[0];
        setFile(fileData);
    };

    const handleUploadPrescription = async () => {
        const url = APIUtils.getAdminAPIEndpoint('upload-prescription');
        const formData = objectToFormData({ prescription: file, apptID: appointment.id });
        setUploading(true);
        const res = await httpClient.post(url, formData).then(res => res.data);
        if (res.status === 'success') {
            Swal.fire('Status!', 'Prescription uploaded successfully!', 'success');
            // Update Selected Appointment
            const appt = {...appointment, prescription: res.data.prescription};
            document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.UPDATE_SELECTED_APPOINTMENT, { detail: appt }));
            // Close Prescription Dialog
            document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.TOGGLE_PRESCRIPTION_DIALOG, { detail: false }));
            // Fetch appointment list
            document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.FETCH_APPOINTMENTS));
        } else {
            Swal.fire('Something Went Wrong!', '', 'error');
        }
        setUploading(false);
    };

    const selectedFileName = file && file.name;

    const uploadBtn = <div className='flex-gap'>
        <Button variant='outlined' component='label'>
            <input
                type='file'
                accept='image/png, application/pdf, image/jpeg'
                hidden={true}
                onChange={handlePrescription}
            />
            Browse Prescription
        </Button>
        <p className='text-ellipsis' title={selectedFileName}>{selectedFileName}</p>
    </div>;

    const uploadingUI = () => {
        if (uploading) {
            return <>
                Uploading...&nbsp;<CgSpinner size={20} className='mt-1 animate-spin' />
            </>;
        }
        return <>Upload</>;
    };

    const btnDisabled = !file || uploading;

    return  <>
        {uploadBtn}
        <DialogActions>
            <Button variant='contained' color='primary' disabled={btnDisabled} onClick={handleUploadPrescription}>
                {uploadingUI()}
            </Button>
        </DialogActions>
    </>;
}

export default PrescriptionDialog;